import dayjs from "dayjs"
import { Timestamp as TimestampType, toDate } from "raml-lib"

export function Timestamp({ value }: { value: TimestampType }) {
  return <small>{dayjs(toDate(value)).format("ll")}</small>
}
